export default {
    name: "sendPrintApplyManage",
	mounted: function () {
		this.init();
	},
    data() {
        return {
            searchForm: {
                companyName: null,
                type: null,
                finalAuditResult: null,
                applyTime: null,
                auditTime: null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
			this.searchForm.companyName="";
			this.searchForm.type="";
            this.searchForm.finalAuditResult="";
            this.searchForm.applyTime= null;
            this.searchForm.auditTime= null
		},
		doAdditionalPrinting(){
			
		},
        doSearch() {
            this.tableData.splice(0, this.tableData.length);
            let param = Object.assign({}, this.searchForm);
            const applyTime = param.applyTime;
            delete param.applyTime;
            if (applyTime) {
                param.applicationTimeStart = applyTime[0];
                param.applicationTimeEnd = applyTime[1];
            }
            const auditTime = param.auditTime;
            delete param.auditTime;
            if (auditTime) {
                param.finalAuditUserDayStart = auditTime[0];
                param.finalAuditUserDayEnd = auditTime[1];
            }
            // 未审核数据
            param = this.$paramUtil.clearEmpty(param);
            this.$axios.get('/api/customerCompay/selectPrintApply', {params: param}).then(response => {
                if (response.data.status === '1') {
                    this.tableData = response.data.resultData.rows;
                    this.total = response.data.resultData.total;
                } else {
                    this.$message({
                        message: this.$t(response.data.message),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doApplyPrinting(){
            // const row = this.getSelectedRow();
			// if (row) {
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
				// conditionData.row = row;
				this.$router.push('PrintApply');
				this.$routerUtil.setParam(conditionData);
			// }
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
